import { inject } from '@angular/core';
import { RouteReloadService } from '../../services/route-reload-service';

export const injectReloadCurrentRoute = () => {
  const routeReloadService = inject(RouteReloadService);
  return () => routeReloadService.reloadCurrentRoute();
};
